export default "/dist/files/icon-coupe-noir.e6b7418dc0fe725df37d1eef542532ce.svg";